export enum ChannelOperatorPriority 
{
    Tier1 = 1,
    Tier2 = 2,
    Tier3 = 3,
    Tier4 = 4,
    Tier5 = 5,
    Tier6 = 6,
    Tier7 = 7,
    Tier8 = 8,
    Tier9 = 9,

    Feedback = 10,
    TierVIP = 11,
    Spam = 12
}